import React, { useEffect } from "react";
import { Card, Col, Container, Row, CardBody, CardHeader } from "reactstrap";

// router
import { Link } from "react-router-dom";

// redux
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { fetchPublicCompanies } from "../../slices/apps/companySlice";

// görsel import
import Logo from "../../assets/images/logo/metiner_avantaj_logo.png";

const BusinessPartners = () => {
  document.title = "İş Ortaklarımız | Metiner Avantaj+";

  const dispatch = useDispatch();

  const { publicCompanies, publicCompaniesLoading } = useSelector((state) => {
    return {
      publicCompanies: state.company.publicCompanies,
      publicCompaniesLoading: state.company.publicCompaniesLoading,
    };
  }, shallowEqual);

  useEffect(() => {
    dispatch(fetchPublicCompanies());
  }, [dispatch]);

  const transformLogoUrl = (url) => {
    if (!url) return null;

    try {
      const path = new URL(url).pathname;

      return `/api${path}`;
    } catch (e) {
      return url.replace("https://api.metiner.com.tr", "/api");
    }
  };

  if (publicCompaniesLoading) {
    return (
      <div id="preloader">
        <div id="status">
          <img
            src={Logo}
            className="mb-2"
            alt="Metiner Avantaj+"
            style={{ objectFit: "contain", width: "10rem" }}
          />
          <div className="spinner-border text-primary avatar-xs" role="status">
            <span className="visually-hidden">Yükleniyor...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <style>
        {`
          .partner-card {
            transition: all 0.3s ease;
            background: #fff;
            border: 1px solid #f3f3f9;
          }
          .partner-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.1);
            border-color: transparent;
          }
          .partner-logo-container {
            height: 90px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px;
          }
          .partner-logo {
            filter: grayscale(100%);
            opacity: 0.7;
            transition: all 0.3s ease;
            max-height: 70px;
            max-width: 100%;
          }
          .partner-card:hover .partner-logo {
            filter: grayscale(0%);
            opacity: 1;
            transform: scale(1.05);
          }
        `}
      </style>

      <div className="auth-page-wrapper d-flex justify-content-center align-items-center min-vh-100">
        <div className="auth-page-content w-100">
          <Container>
            <Row className="justify-content-center">
              <Col md={12}>
                <div className="text-center pt-4 mb-4">
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={Logo} alt="Metiner Avantaj+" height="80" />
                  </Link>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col xl={10}>
                <Card className="overflow-hidden shadow-lg border-0">
                  <CardHeader className="bg-primary bg-opacity-10 border-0 py-4">
                    <div className="text-center">
                      <h5 className="mb-1 text-primary fw-bold">
                        İş Ortaklarımız
                      </h5>
                      <p className="text-muted mb-0 fs-13">
                        Güçlü iş birliklerimiz ile size en iyi hizmeti
                        sunuyoruz.
                      </p>
                    </div>
                  </CardHeader>

                  <CardBody className="p-5 bg-light bg-opacity-10">
                    <Row className="g-4">
                      {publicCompanies && publicCompanies.length > 0 ? (
                        publicCompanies.map((partner, key) => (
                          <Col xs={6} md={4} lg={3} key={key}>
                            <div className="partner-card h-100 rounded-3 p-3 text-center position-relative">
                              <div className="partner-logo-container mb-2">
                                {partner.companyLogoUrl ? (
                                  <img
                                    src={transformLogoUrl(
                                      partner.companyLogoUrl,
                                    )}
                                    alt={partner.companyTableName}
                                    className="partner-logo img-fluid"
                                  />
                                ) : (
                                  <div className="text-muted opacity-25">
                                    <i className="ri-building-line ri-4x"></i>
                                  </div>
                                )}
                              </div>
                              <h6 className="mb-0 text-dark fw-semibold fs-12 text-truncate">
                                {partner.companyTableName}
                              </h6>
                              <div className="mt-2 border-top border-light w-25 mx-auto"></div>
                            </div>
                          </Col>
                        ))
                      ) : (
                        <Col xs={12}>
                          <div className="text-center py-5">
                            <div className="avatar-lg mx-auto mb-3">
                              <div className="avatar-title bg-light text-primary rounded-circle display-5">
                                <i className="ri-folder-info-line"></i>
                              </div>
                            </div>
                            <h5 className="text-muted">
                              Henüz listelenecek iş ortağı bulunmamaktadır.
                            </h5>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

        <footer className="footer h-auto pb-2">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center text-muted">
                  <p className="mb-2" style={{ letterSpacing: "0.8px" }}>
                    Metiner Avantaj+ &copy; {new Date().getFullYear()} | 0 352 3
                    555 444 | metiner@boschservice.com.tr
                    <br />
                    <i className="mdi mdi-heart text-danger"></i> by{" "}
                    <a
                      href="https://kodexis.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "#007bff" }}
                    >
                      Kodexis
                    </a>
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default BusinessPartners;
